"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatePromoCodeResponseToJSON = exports.ValidatePromoCodeResponseFromJSONTyped = exports.ValidatePromoCodeResponseFromJSON = void 0;
function ValidatePromoCodeResponseFromJSON(json) {
    return ValidatePromoCodeResponseFromJSONTyped(json, false);
}
exports.ValidatePromoCodeResponseFromJSON = ValidatePromoCodeResponseFromJSON;
function ValidatePromoCodeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isValid': json['isValid'],
    };
}
exports.ValidatePromoCodeResponseFromJSONTyped = ValidatePromoCodeResponseFromJSONTyped;
function ValidatePromoCodeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'isValid': value.isValid,
    };
}
exports.ValidatePromoCodeResponseToJSON = ValidatePromoCodeResponseToJSON;
//# sourceMappingURL=ValidatePromoCodeResponse.js.map